import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import HeadingComp from '../Components/HeadingComp'

const Privacypage = () => {
  return (
    <div>
      <Navbar />

      <div>
        <div className='w-full max-w-[1212px] max_xl1460:max-w-[980px] max_1024:px-10 max_500:px-5 m-auto my-[100px] max_500:my-[50px] max_768:my-[60px]'>
          <HeadingComp head1="Privacy Policy" head2="" />
          <p className='Text18Sans mt-[30px] max_500:mt-5'>At Trisol Lubricants, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect the data you share with us through Facebook Instant Forms and other communication channels.
          </p>

          <div className='flex flex-col gap-10 max_500:gap-6 mt-[30px] max_1024:mt-5 '>
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>1. Information We Collect</h3>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'> When you interact with our Facebook Instant Form or contact us, we may collect the following information:
              </p>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Your name</p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Phone number
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Email address</p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Business name (if applicable)</p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Any other details you choose to provide
                  </p>
                </div>
              </div>
            </div>

            {/* 2nd */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>2. How We Use Your Information</h3>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'>  The information you provide will be used for the following purposes:

              </p>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>To contact you regarding your inquiry or interest in our products and services.
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>To provide information about our lubricants and related offerings.
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>To improve our services and customer experience.
                  </p>
                </div>
              </div>
              <p className='Text18Sans mt-2'>We do not sell, share, or disclose your personal information to third parties except as necessary to fulfill your requests or comply with legal obligations.
              </p>
            </div>

            {/* 3 rd */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>3. Data Protection</h3>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'> We take appropriate technical and organizational measures to protect your personal data from unauthorized access, loss, or misuse.
              </p>
            </div>

            {/* 4 th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>4. Your Rights</h3>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'>You have the right to:</p>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Access the personal information we have about you.
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Request corrections to your information.
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Request deletion of your data.
                  </p>
                </div>
              </div>
              <p className='Text18Sans mt-2'>To exercise these rights, you can contact us using the details provided below.</p>
            </div>

            {/* 5th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>5. Contact Us</h3>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'> If you have any questions about this Privacy Policy or how we handle your data, please contact us:</p>
              <h3 className='text-[22px] max_xl1460:text-[20px] font-MontserratF font-medium mt-2'>Trisol Lubricants</h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Phone:</span><a href='tel:6354527074'>+91 63545 27074</a>
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Email:</span> Trisol@gmail.com
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Website:</span> <a href='https://www.trisollubricant.com/' className='text-[#1155cc]'>www.trisollubricant.com</a>
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Address:</span> Block No. E-37, Hindva Dreams, Dhoran Pardi Gaypagla Road, Kamrej, Surat, Gujarat-394155
                  </p>
                </div>
              </div>
            </div>

            {/* 6 th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>6. Updates to This Policy
              </h3>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'>We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We encourage you to review this policy periodically.</p>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'>By submitting your information through our Facebook Instant Form, you agree to this Privacy Policy.</p>
            </div>



          </div>
        </div>

      </div>

      <Footer />
    </div>
  )
}

export default Privacypage
